import { LabelValueForText } from "components/ui/atoms/LabelValue";
import { getCommons } from "./fieldConverterHelpers";

export const NumberFieldView = ({ field, formattedValue }) => {
  return (
    <LabelValueForText
      label={field.label}
      sx={{ display: field.hidden ? "none" : "inherit" }}
      value={formattedValue || ""}
      isMissing={
        formattedValue === undefined ||
        formattedValue === null ||
        formattedValue.toString().trim() === ""
      }
    />
  );
};

const simpleNumberFormatter =
  (minimumFractionDigits = 2, maximumFractionDigits = 2) =>
  (num) => {
    num = Number(num);
    if (isNaN(num)) return "";
    return num.toLocaleString(undefined, {
      minimumFractionDigits,
      maximumFractionDigits,
    });
  };

export const numberFieldConverter = ({ field }) => {
  return {
    ...getCommons({ field }),
    type: "number",
    valueFormatter: simpleNumberFormatter(0, 0),
  };
};
